import { SearchEventsRefinements } from 'modules/search/pages/Events/components/SearchEventsRefinements';
import { SearchInternshipRefinements } from 'modules/search/pages/Internships/components/SearchInternshipRefinements';
import { SearchJobsRefinements } from 'modules/search/pages/Jobs/components/SearchJobsRefinements';
import { SearchOrgRefinements } from 'modules/search/pages/Orgs/components/SearchOrgRefinements';
import { SearchVolopsRefinements } from 'modules/search/pages/Volops/components/SearchVolopsRefinements';
import type { ListingType } from 'types/ListingType';

type Args = {
  searchType: ListingType | undefined;
};

export function SearchRefinementsSwitch({ searchType }: Args) {
  switch (searchType) {
    case 'JOB':
      return <SearchJobsRefinements />;
    case 'INTERNSHIP':
      return <SearchInternshipRefinements />;
    case 'VOLOP':
      return <SearchVolopsRefinements />;
    case 'ORG':
      return <SearchOrgRefinements />;
    case 'EVENT':
      return <SearchEventsRefinements />;
    case undefined:
      return null;
  }
}
